import React, { useEffect, useState } from 'react';
import Layout from '../../common/Layout';
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';

const MmvMaster = () => {
  const mmvData = useSelector(state => state?.root?.mmvData);
  const dispatch = useDispatch();

  const [insurerData, setInsurerData] = useState([]);
  const [vehicleType, setVehicleType] = useState('');
  const [insurer, setInsurer] = useState('');
  const [insurerName, setInsurerName] = useState('');
  const [insurerMasterData, setInsurerMasterData] = useState([])



  const [uploadType, setUploadType] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showAddRow, setShowAddRow] = useState(false);
  const [formData, setFormData] = useState({});
  const [hasFetched, setHasFetched] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  });

  const canSelectMasterType = Boolean(vehicleType && insurer);
  const canUpload = Boolean(canSelectMasterType && uploadType);

  // ================= VEHICLE =================
  const handleVehicle = (val) => {
    setVehicleType(val);
    setInsurer('');
    setUploadType('');
    setSelectedFile(null);
    dispatchMmvData('vehicleType', val);
  };

  // ================= INSURERS =================
  const loadInsurers = async () => {
    try {
      const res = await GetDataWithToken('/insurers/getAllInsurer');
      if (res?.success) setInsurerData(res?.data || []);
    } catch (e) {
      console.log(e);
    }
  };
  const InsurerMaster = async (
    masterType,
    insurer,
    page = currentPage,
    limit = itemsPerPage
  ) => {
    setLoading(true);

    const insurerObj = {
      insurer,
      masterType,
      page,
      limit,
    };

    try {
      const res = await PostDataWithToken(
        "master-data/getInsurerMasterData",
        insurerObj
      );

      if (res?.status) {
        setInsurerMasterData(res.data || []);
        setPagination(res.pagination || {});
        setCurrentPage(page);
        if (res?.message) {
          toast.success(res.message);
        }
      } else {
        setInsurerMasterData([]);
        toast.error(
          res?.displayMessage ||
            res?.errorMessage ||
            res?.message ||
            "Unable to fetch master data"
        );
        setPagination({
          total: 0,
          page: 1,
          limit,
          totalPages: 0,
        });
      }
    } catch (error) {

      setInsurerMasterData([]);
      toast.error(
        error?.response?.data?.displayMessage ||
          error?.displayMessage ||
          error?.response?.data?.errorMessage ||
          error?.errorMessage ||
          error?.message ||
          "Unable to fetch master data"
      )
      setPagination({
        total: 0,
        page: 1,
        limit,
        totalPages: 0,
      });
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  const hiddenColumns = [
    "id",

    "financerId",

    "createdAt",
    "updatedAt",
    // "mmvFullName",
    "isActive",

    "__v",
  ];

  // These values come from the MMV master response and must not be edited.
  const disabledFields = new Set(["insFastVehicleType", "mmvFullName","rtoFullName"]);

  const columns =
    insurerMasterData.length > 0
      ? Object.keys(insurerMasterData[0]).filter(
        (key) => !hiddenColumns.includes(key)
      )
      : [];


  const renderCellValue = (value) => {
    // null / undefined / empty string
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    // Boolean
    if (typeof value === "boolean") {
      return value ? (
        <span className="badge bg-success">Yes</span>
      ) : (
        <span className="badge bg-danger">No</span>
      );
    }

    // Object (like declined)
    if (typeof value === "object") {
      const entries = Object.entries(value);

      if (entries.length === 0) return "-";

      return (
        <div className="d-flex flex-wrap gap-1">
          {entries.map(([key, val]) => (
            <span
              key={key}
              className={`badge ${val ? "bg-danger" : "bg-secondary"
                }`}
            >
              {key} : {String(val)}
            </span>
          ))}
        </div>
      );
    }

    // String / Number
    return value;
  };

  useEffect(() => {
    if (vehicleType && mmvData?.apiUrl) {
      loadInsurers();
    }
  }, [vehicleType, mmvData?.apiUrl]);



  // ================= INSURER =================
  const handleInsurer = (val, list) => {
    debugger
    setInsurer(val);
    setUploadType('');
    setSelectedFile(null);
    const selected = list.find(x => x.insurerId == val);
    setInsurerName(selected?.mappingName || '');
    dispatchMmvData('insurerId', val);
    dispatchMmvData('insurerName', selected?.insurerName || '');
    dispatchMmvData('mappingName', selected?.mappingName || '');
  };
  const handleMasterType = (e) => {
    const value = e.target.value;

    dispatchMmvData("masterType", value);
    setUploadType(value);
    setCurrentPage(1);

    if (!value) {
      setInsurerMasterData([]);
      setHasFetched(false);
      return;
    }

    InsurerMaster(value, mmvData?.mappingName, 1, itemsPerPage);
  };
  // ================= FILE =================
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    const allowed = ['csv', 'xls', 'xlsx'];

    if (!allowed.includes(ext)) {
      alert('Only CSV, XLS, XLSX allowed');
      e.target.value = '';
      return;
    }

    setSelectedFile(file);
  };


  // ================= UPLOAD (FIXED 100%) =================
  const handleUpload = async () => {
    if (!vehicleType || !insurer || !uploadType || !selectedFile) {
      toast.error('Please fill all fields');
      return;
    }

    const formData = new FormData();
    formData.append('masterType', uploadType);
    formData.append('vehicleType', vehicleType);
    formData.append('insurer', insurerName);
    formData.append('file', selectedFile);

    // 🔥 DEBUG (IMPORTANT)
    for (let pair of formData.entries()) {
      console.log('FORMDATA:', pair[0], pair[1]);
    }

    try {
      setLoading(true);

      const token = localStorage.getItem('accessToken');


      const response = await fetch('https://uatmasterapi.flaskitsolutions.com/master-data/upload', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
          // ❗ NEVER set Content-Type here
        },
        body: formData
      });

      const data = await response.json();


      if (response) {
        toast.success(response.message);

        setVehicleType('');
        setInsurer('');
        setUploadType('');
        setSelectedFile(null);
      } else {
        toast.error(data?.message || 'Upload failed');
      }

    } catch (error) {
      toast.error('Upload error');
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const isFieldDisabled = (fieldName) => disabledFields.has(fieldName);
  const handleSubmit = async () => {

    // Example Payload
    const payload = {
      insurer: mmvData.mappingName,
      masterType: uploadType,
      ...formData,
    };

    try {
      const res = await PostDataWithToken(
        "master-data/addInsurerMasterData",
        payload
      );

      if (res) {
        toast.success(res.message);

        setShowAddRow(false);
        setFormData({});

        InsurerMaster(mmvData.masterType, mmvData.mappingName);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message)
    }
  };
  const handlePageClick = ({ selected }) => {
    const page = selected + 1;

    setCurrentPage(page);

    InsurerMaster(mmvData?.masterType, mmvData?.mappingName, page, itemsPerPage);
  };
  const handleChangeItemPerPage = (value) => {
    const limit = Number(value);

    setItemsPerPage(limit);

    InsurerMaster(
      mmvData?.masterType,
      mmvData?.mappingName,
      1,
      limit
    );
  };


  return (
    <Layout>
      <div className="mt-7 mx-4">
        <div className="card ">
          <div className="card-body">
            <div className="row">

              {/* VEHICLE TYPE */}
              <div className="col-md-4">
                <label>Vehicle Type</label>
                <select
                  className="form-control"
                  value={vehicleType}
                  onChange={(e) => handleVehicle(e.target.value)}
                >
                  <option value=''>Select Vehicle</option>
                  <option value='2w'>Two Wheeler</option>
                  <option value='4w'>Private Car</option>
                  <option value='pcv'>Passenger Carrying Vehicle</option>
                  <option value='gcv'>Goods Carrying Vehicle</option>
                  <option value='misc'>Miscellaneous Vehicle</option>
                </select>
              </div>

              {/* INSURER */}
              <div className="col-md-4">
                <label>Insurer</label>
                <select
                  className="form-control"
                  value={insurer}
                  onChange={(e) => handleInsurer(e.target.value, insurerData)}
                >
                  <option value="">Select Insurer</option>
                  {insurerData.map((i, idx) => (
                    <option key={idx} value={i.insurerId}>
                      {i.mappingName}
                    </option>
                  ))}
                </select>
              </div>

              {/* MASTER TYPE */}
              <div className="col-md-4">
                <label>Master Type</label>
                <select
                  className="form-control"
                  value={uploadType}
                  onChange={handleMasterType}
                  // disabled={!canSelectMasterType}
                >
                  <option value="">Select Master Type</option>
                  <option value="mmv">MMV</option>
                  <option value="rto">RTO</option>
                  <option value="pincode">Pincode</option>
                  <option value="relation">Relation</option>
                  <option value="prevInsurer">Prev Insurer</option>
                  <option value="financier">Financier</option>
                  <option value="occupation">Occupation</option>
                  <option value="exshowroom">Ex Showroom</option>
                </select>
              </div>

              {/* FILE */}
              <div className="col-md-4 mt-3">
                <label>File</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".csv,.xls,.xlsx"
                  onChange={handleFileChange}
                  // disabled={!canUpload}
                />
              </div>

              {/* BUTTON */}
              <div className="col-md-4 mt-3 ">
                <label></label>

                <button
                  className="btn btn-sec w-100"
                  onClick={handleUpload}
                  disabled={loading || !canUpload || !selectedFile}
                >
                  {loading ? 'Uploading...' : 'Upload'}
                </button>
              </div>
  { 
    uploadType && 
       <div className="d-flex justify-content-end mb-3">
                <button
                  className="btn btn-sec"
                  onClick={() => {
                    setShowAddRow(true);

                    const obj = {};
                    columns.forEach((col) => {
                      obj[col] = "";
                    });

                    setFormData(obj);
                  }}
                >
                  + Add {uploadType}
                </button>
              </div>
  } 
           

            </div>
          </div>
        </div>


        <div className="table-responsive mt-3">

          {loading ? (
            <div className="text-center py-4">
              <h5>Loading...</h5>
            </div>
          ) : insurerMasterData.length > 0 || showAddRow ? (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>


                    {columns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}

                    {showAddRow && <th>Action</th>}
                  </tr>
                </thead>

                <tbody>

                  {/* Add Row */}
                  {showAddRow && (
                    <tr>
                      {columns.map((col) => (
                        <td key={col}>
                          <input
                            type="text"
                            className="form-control"
                            value={formData[col] || ""}
                            disabled={isFieldDisabled(col)}
                            onChange={(e) =>
                              handleInputChange(col, e.target.value)
                            }
                          />
                        </td>
                      ))}

                      <td>
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={handleSubmit}
                        >
                          Save
                        </button>

                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={() => {
                            setShowAddRow(false);
                            setFormData({});
                          }}
                        >
                          Cancel
                        </button>
                      </td>
                    </tr>
                  )}

                  {/* Existing Data */}
                  {insurerMasterData.map((item, index) => (
                    <tr key={item.id || index}>


                      {columns.map((col) => (
                        <td key={col}>
                          {renderCellValue(item[col])}
                        </td>
                      ))}
                    </tr>
                  ))}

                </tbody>
              </table>
              <div className="card mb-4 p-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap">

                  <div>
                    <p className="mb-0">
                      Showing{" "}
                      <strong>
                        {pagination.total === 0
                          ? 0
                          : (currentPage - 1) * itemsPerPage + 1}
                      </strong>{" "}
                      -
                      <strong>
                        {" "}
                        {Math.min(currentPage * itemsPerPage, pagination.totalRecords)}
                      </strong>{" "}
                      of <strong>{pagination.totalRecords}</strong> entries
                    </p>
                  </div>

                  <div className="d-flex align-items-center gap-3">

                    <select
                      className="form-select"
                      style={{ width: "90px" }}
                      value={itemsPerPage}
                      onChange={(e) => handleChangeItemPerPage(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>

                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=">"
                      previousLabel="<"
                      onPageChange={handlePageClick}
                      pageCount={pagination.totalPages || 0}
                      forcePage={currentPage - 1}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      renderOnZeroPageCount={null}
                      containerClassName="pagination mb-0"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      disabledClassName="disabled"
                    />

                  </div>

                </div>
              </div>
            </>
          ) : hasFetched ? (

            <div className="text-center py-5 border rounded">
              <h5 className="text-muted mb-0">No Data Found</h5>
            </div>

          ) : null}

        </div>
      </div>


      {loading && (
        <div className="loader-overlay">
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              role="status"
            />
            <h5 className="mt-3">
              Updating Status...
            </h5>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default MmvMaster;
